import { InjectionToken } from '@angular/core';

export const FEATURE_ROOT = new InjectionToken<string>('Feature root');
